import { useQuery } from '@apollo/client/react';
import { Select, Table, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Spacer } from '../../components/Spacer';
import { ADMIN_EXECUTORS } from '../../gqls/executor';
import { executorCategories } from '../../utils';

const TAKE = 50;

export const PageExecutors = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [filterStatus, setFilterStatus] = useState(undefined);
  const [filterCategory, setFilterCategory] = useState(undefined);

  const { data, loading } = useQuery(ADMIN_EXECUTORS, {
    variables: {
      where: {
        status: filterStatus || undefined,
        category: filterCategory || undefined,
      },
      take: TAKE,
      skip: (currentPage - 1) * TAKE,
    },
  });
  const adminExecutors = data?.adminExecutors || [];
  const adminExecutorsCount = data?.adminExecutorsCount || 0;
  const getExecutorCategories = (executor) =>
    executor?.categories?.length ? executor.categories : executor?.category ? [executor.category] : [];

  return (
    <>
      <Typography.Title level={5} style={{ margin: 0 }}>
        Исполнители ({adminExecutorsCount})
      </Typography.Title>
      <Spacer h={12} />
      <ContentTable>
        <Filter>
          <Select
            allowClear
            onChange={(v) => setFilterStatus(v)}
            placeholder="Статус"
            options={[
              { label: 'Новый', value: 'new' },
              { label: 'Одобрен', value: 'approved' },
              { label: 'Отменен', value: 'cancelled' },
            ]}
            style={{ width: 200 }}
          />
          <Spacer w={16} />
          <Select
            allowClear
            onChange={(v) => setFilterCategory(v)}
            placeholder="Категория"
            options={executorCategories.map((item) => ({ label: item.singleLabel, value: item.value }))}
            style={{ width: 200 }}
          />
        </Filter>
        <Spacer h={12} />
        <Table
          size="middle"
          loading={loading}
          dataSource={adminExecutors}
          columns={[
            {
              key: 'id',
              dataIndex: 'id',
              title: 'ID',
              render: (id) => <Link to={`/executors/${id}`}>{id.slice(0, 8)}...</Link>,
            },
            {
              key: 'fullName',
              dataIndex: 'fullName',
              title: 'Имя',
              render: (fullName) => fullName || '',
            },
            {
              key: 'category',
              dataIndex: 'categories',
              title: 'Категория',
              className: 'category-column',
              render: (_, executor) => {
                const categories = getExecutorCategories(executor);
                return categories.map((item) => {
                  const category = executorCategories.find((c) => c.value === item);
                  return category ? <Tag key={item}>{category.label}</Tag> : <Tag key={item}>{item}</Tag>;
                });
              },
            },
            {
              key: 'status',
              dataIndex: 'status',
              title: 'Статус',
              render: (status) => {
                if (status === 'new') return <Tag color="blue">Новый</Tag>;
                if (status === 'approved') return <Tag color="green">Одобрен</Tag>;
                if (status === 'cancelled') return <Tag color="red">Отменен</Tag>;
                return status;
              },
            },
            {
              key: 'createdAt',
              dataIndex: 'createdAt',
              title: 'Создан',
              render: (date) => dayjs(date).format('DD.MM.YYYY HH:mm'),
            },
          ]}
          pagination={{
            current: currentPage,
            total: adminExecutorsCount,
            pageSize: TAKE,
            onChange: (page) => {
              setCurrentPage(page);
            },
          }}
        />
      </ContentTable>
    </>
  );
};

const ContentTable = styled.div`
  overflow-x: auto;

  table {
    min-width: 1100px;
  }

  .category-column {
    max-width: 200px;
  }
`;

const Filter = styled.div`
  display: flex;
  flex-direction: row;
`;
